// sm-footer-live: single-open link column accordion on mobile (ported behavior from
// the live smn-footer section), plus the locale <details> outside-click/Esc close.
// On submit, remembers the chosen language in a cookie so sm-geo-redirect never
// overrides a deliberate manual choice.
document.addEventListener('click', (e) => {
  const head = e.target.closest('.sm-footer-live [data-live-footer-col-toggle]');
  if (head) {
    if (window.innerWidth > 989) return; // desktop: columns are always open
    const col = head.closest('.sm-footer-live__col');
    const wasOpen = col.hasAttribute('data-open');
    document.querySelectorAll('.sm-footer-live__col[data-open]').forEach((c) => c.removeAttribute('data-open'));
    if (!wasOpen) col.setAttribute('data-open', '');
    return;
  }
  document.querySelectorAll('.sm-footer-live__locale[open]').forEach((el) => {
    if (!el.contains(e.target)) el.removeAttribute('open');
  });
});

document.addEventListener('keydown', (e) => {
  if (e.key !== 'Escape') return;
  document.querySelectorAll('.sm-footer-live__locale[open]').forEach((el) => {
    el.removeAttribute('open');
    el.querySelector('summary')?.focus();
  });
});

document.querySelectorAll('#sm-footer-live-locale-form [data-live-locale-select]').forEach((select) => {
  if (select.name !== 'locale_code') return;
  select.addEventListener('change', () => {
    document.cookie = `sm-lang=${select.value};path=/;max-age=31536000;samesite=lax`;
  });
});
